<div fxLayout="column" fxLayoutAlign="center center" style="margin-top: 80px;">
  <h2>Πλοήγηση</h2>
  <mat-list>
    <mat-list-item class="listItem" *ngFor="let item of paths" mat-list-item (click)="onClose(item)">
      <img *ngIf="item.imageType && item.imageType==='image'" [src]="item.image" alt="" class="navigationImage">
      <mat-icon *ngIf="item.imageType && item.imageType==='icon'">{{item.image}}</mat-icon>
      &nbsp;
      {{item.title}}</mat-list-item>
  </mat-list>
</div>
